module.exports = "<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 485.411 485.411\" style=\"enable-background:new 0 0 485.411 485.411;\" xml:space=\"preserve\"><g><path d=\"M0,81.824v321.763h485.411V81.824H0z M242.708,280.526L43.612,105.691h398.187L242.708,280.526z M163.397,242.649L23.867,365.178V120.119L163.397,242.649z M181.482,258.533l61.22,53.762l61.22-53.762L441.924,379.72H43.487 L181.482,258.533z M322.008,242.655l139.535-122.536v245.059L322.008,242.655z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./blocks/ContactBanner/assets/envelope.svg
// module id = 624
// module chunks = 0 1